import {
  BORDER_FOCUSED_COLOR,
  BUTTON_FOCUSED_COLOR,
  DEFAULT_BORDER_COLOR,
  ERROR_COLOR,
  HEADER_COLOR,
  PRIMARY_COLOR,
} from './styleVariables';

const getFocusedBorderColor = ({ hasError }) =>
  hasError ? ERROR_COLOR : BORDER_FOCUSED_COLOR;

const getDefaultInputStyles = (props = {}) => `
  background-color: ${props.backgroundColor || '#fff'};
  border-color: ${props.hasError ? ERROR_COLOR : DEFAULT_BORDER_COLOR};
  border-style: ${props.borderStyle || 'solid'};
  font-size: ${props.fontSize || '15px'};
  height: ${props.height || '48px'};
  outline: 0;
  padding: ${props.padding || '16px 39px 0 15px'};
  width: 100%;

  :focus {
    border-color: ${getFocusedBorderColor(props)};
    box-shadow: 0 0 0 1px ${getFocusedBorderColor(props)};

    + label {
      color: ${props.hasError ? ERROR_COLOR : PRIMARY_COLOR};
      transform: translate3d(0, -7px, 0) scale(0.8);
    }
  }

  :-webkit-autofill,
  :-webkit-autofill:focus {
    -webkit-text-fill-color: ${HEADER_COLOR};
    -webkit-box-shadow: 0 0 0px 1000px ${props.backgroundColor || '#fff'} inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  :-webkit-autofill {
    border-color: ${DEFAULT_BORDER_COLOR};
  }

  :-webkit-autofill:focus {
    border-color: ${BORDER_FOCUSED_COLOR};
  }
`;

const getDefaultButtonStyles = (props = {}) => `
  background-color: ${props.backgroundColor || PRIMARY_COLOR};
  border: none;
  border-radius: 23px;
  color: ${props.color || '#fff'};
  cursor: pointer;
  display: ${props.display || 'initial'};
  font-size: 15px;
  height: 48px;
  line-height: ${48 / 15};
  margin-bottom: ${props.marginBottom || '18px'};
  text-align: center;
  width: ${props.width || '100%'};

  :focus,
  :hover {
    background-color: ${props.backgroundColorFocus || BUTTON_FOCUSED_COLOR};
    text-decoration: underline;
  }
`;

export { getDefaultButtonStyles, getDefaultInputStyles };
